export default __webpack_public_path__ + "static/bbq-3-b-72a10005defa8d817b2414b0cc7f2782.webp";